import React from "react";
import { Box, Typography } from "@mui/material";
import apiClient from "../utils/apiClient";
import { useNavigate } from "react-router-dom";
import { useUser, useUserActions } from "../pages/UserContext";
import CustomButton from "./custom/CustomButton";

const ImpersonationBanner = () => {
  const userDetails = useUser();
  const { refetchUser } = useUserActions();
  const navigate = useNavigate();

  const impersonator = userDetails?.impersonator;
  if (!impersonator) return null;

  const handleReturn = async () => {
    try {
      // Mints a fresh cookie session for the admin server-side; there's no
      // stashed client token to restore anymore.
      await apiClient.post("/impersonate/end", {});
    } catch (error) {
      console.error("Failed to log end of impersonation", error);
    }

    await refetchUser();
    navigate("/member-card");
  };

  return (
    <Box
      sx={{
        backgroundColor: "#003158",
        color: "#ffffff",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 1,
        padding: "8px 20px",
      }}
    >
      <Typography sx={{ fontWeight: 600, fontSize: "0.9rem" }}>
        Sedang login sebagai akun {impersonator.namaLengkap} - {impersonator.accessRoleName} (ID:{" "}
        {impersonator.id})
      </Typography>
      <CustomButton
        text="Kembali ke Akun Saya"
        baseColor="#000000"
        hoverColor="#333333"
        isFullWidth={false}
        onClick={handleReturn}
      />
    </Box>
  );
};

export default ImpersonationBanner;
